import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { ZIP_CODE_REGEX } from 'commons/constants';
import { BANNER_IMAGE_URL } from './helpers';
const INVALID_ZIP_MESSAGE = 'Please enter a 5-digit zip code.';
const StoreLocatorSearch = t0 => {
  const $ = _c(26);
  const {
    zipcode,
    onZipcodeChange,
    onSearch,
    onViewAll
  } = t0;
  const [error, setError] = useState("");
  let t1;
  if ($[0] !== error || $[1] !== onZipcodeChange) {
    t1 = event => {
      onZipcodeChange(event.target.value);
      if (error) {
        setError("");
      }
    };
    $[0] = error;
    $[1] = onZipcodeChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleZipChange = t1;
  let t2;
  if ($[3] !== onSearch || $[4] !== onViewAll || $[5] !== zipcode) {
    t2 = event_0 => {
      event_0.preventDefault();
      const trimmed = zipcode.trim();
      if (!trimmed) {
        setError("");
        onViewAll();
        return;
      }
      if (!ZIP_CODE_REGEX.test(trimmed)) {
        setError(INVALID_ZIP_MESSAGE);
        return;
      }
      setError("");
      onSearch(trimmed);
    };
    $[3] = onSearch;
    $[4] = onViewAll;
    $[5] = zipcode;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleSubmit = t2;
  let t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      backgroundImage: `url(${BANNER_IMAGE_URL})`
    };
    t4 = <div className="absolute inset-0 bg-black/40" />;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  const t5 = error ? "true" : "false";
  const t6 = error ? "store-locator-zipcode-error" : undefined;
  let t7;
  if ($[9] !== handleZipChange || $[10] !== t5 || $[11] !== t6 || $[12] !== zipcode) {
    t7 = <input id="store-locator-zipcode" name="zipcode" type="text" inputMode="numeric" placeholder="Zip Code" aria-label="Zip code" aria-invalid={t5} aria-describedby={t6} value={zipcode} onChange={handleZipChange} maxLength="5" autoComplete="postal-code" className="flex-1 min-w-0 px-3 py-2 bg-white text-base text-gray-dark placeholder-gray-light3 outline-none focus:ring-2 focus:ring-brand" />;
    $[9] = handleZipChange;
    $[10] = t5;
    $[11] = t6;
    $[12] = zipcode;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <button type="submit" data-xc="StoreLocatorSearchButton" className="px-6 bg-brand text-white text-base whitespace-nowrap hover:bg-gray-dark transition-colors">Find Showroom</button>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7) {
    t9 = <div className="flex items-stretch min-w-0">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== error) {
    t10 = error && <div id="store-locator-zipcode-error" role="alert" className="mt-1 text-sm text-white bg-red/80 px-2 py-1 rounded-sm">{error}</div>;
    $[17] = error;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== onViewAll) {
    t11 = <div className="mt-2"><button type="button" data-xc="StoreLocatorViewAllButton" onClick={onViewAll} className="text-sm text-white underline hover:text-gray-light6">View All</button></div>;
    $[19] = onViewAll;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== handleSubmit || $[22] !== t10 || $[23] !== t11 || $[24] !== t9) {
    t12 = <div className="relative w-full h-56 bg-center bg-cover" style={t3}>{t4}<div className="relative z-10 flex flex-col items-center justify-center h-full px-4"><div className="w-full max-w-2xl flex flex-col"><form onSubmit={handleSubmit} className="flex flex-1 flex-col min-w-0">{t9}{t10}{t11}</form></div></div></div>;
    $[21] = handleSubmit;
    $[22] = t10;
    $[23] = t11;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};
StoreLocatorSearch.propTypes = {
  zipcode: PropTypes.string.isRequired,
  onZipcodeChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onViewAll: PropTypes.func.isRequired
};
export default StoreLocatorSearch;